import { QuoteDetail } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface QuoteLinesState extends EntityState<QuoteDetail> {}

export const quoteLinesAdapter: EntityAdapter<QuoteDetail> = createEntityAdapter<QuoteDetail>({
  selectId: (quoteDetail: QuoteDetail) => quoteDetail.id
});
export const initialQuoteLinesState: QuoteLinesState = quoteLinesAdapter.getInitialState({});
